import React from "react";
import appNameImg from "../../assets/app_name.png";
import videoCallImg from "../../assets/video_call.png";
const HeroComponent = () => {
  return (
    <>
      <p>社会人や大学生のための</p>
      <p>モチベーションサポートアプリ</p>
      <div className="app-name-img">
        <img src={appNameImg} />
      </div>
      <div className="video-call-img">
        <img src={videoCallImg} />
      </div>
    </>
  );
};
export default HeroComponent;